import { render, staticRenderFns } from "./paginationApi.vue?vue&type=template&id=6e4f040c&scoped=true"
import script from "./paginationApi.vue?vue&type=script&lang=js"
export * from "./paginationApi.vue?vue&type=script&lang=js"
import style0 from "./paginationApi.vue?vue&type=style&index=0&id=6e4f040c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e4f040c",
  null
  
)

export default component.exports